import {faLocation, faLocationDot} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from 'react';

const PersonInfo = () => {
    return (
        <div className="mt-10">
            <div className="flex gap-2">
                <div><img className="w-10 rounded-full" src="images/dp.jpg" alt="" /></div>
                <div>
                    <h3 className="text-sm">Kaium Uddin</h3>
                    <p className="text-xs text-slate-400">
                        <FontAwesomeIcon className="mr-1" icon={faLocationDot}></FontAwesomeIcon>
                        Chattogram, Bangladesh</p>
                </div>
            </div>
            <div className="mt-5 border-lime-500 border-2  bg-lime-100 rounded-md p-4 grid grid-cols-1 md:grid-cols-3 gap-1">
                <div className="grid grid-cols-2 md:block">
                    <h3 className="font-medium">78 <span className="text-xs text-slate-400">kg</span> </h3>
                    <h3 className="text-slate-500">Weight</h3>
                </div >
                <div className="grid grid-cols-2 md:block">
                    <h3 className="font-medium">5.10</h3>
                    <h3 className="text-slate-500">Height</h3>
                </div>
                <div className="grid grid-cols-2 md:block">
                    <h3 className="font-medium">25 <span className="text-xs text-slate-400">yr</span> </h3>
                    <h3 className="text-slate-500">Age</h3>
                </div>
            </div>
        </div>
    );
};

export default PersonInfo;